import { Icon } from '@/components'
import { ReactNode } from 'react'

const conversionData = [
  {
    title: 'WHAT CAN I CONVERT?',
    icon: <Icon name="eligible" />,
    items: [
      'Post-redemption Digital Pop! collections',
      'Stickers',
      'Non-redemption Digital Pop collections like Bonus Digital Pop!, Digital Pop! Promo, etc.'
    ]
  },
  {
    title: 'WHAT IS INELIGIBLE TO CONVERT?',
    icon: <Icon name="inEligible" />,
    items: [
      'Packs, Crates, and Redemption Tokens',
      'Pre-redemption Digital Pop! collections',
      'Droppp Monsters'
    ]
  }
]

const ArcadeOverviewConvertEligibility = () => {
  return (
    <div className="flex flex-col items-center max-w-[752px] gap-4">
      {conversionData.map((data, index) => (
        <ArcadeOverviewConvertEligibilityBox key={index} {...data} />
      ))}
    </div>
  )
}

export default ArcadeOverviewConvertEligibility

const ArcadeOverviewConvertEligibilityBox = ({
  title,
  icon,
  items
}: {
  title: string
  icon: ReactNode
  items: string[]
}) => {
  return (
    <div className="w-full border border-gray-800 rounded-[32px] p-4">
      <div className="flex items-center gap-[12px] mb-[10px]">
        {icon}
        <h5 className="h5">{title}</h5>
      </div>
      <ul className="text-gray-300 body-md list-outside list-disc pl-[23px]">
        {items.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </div>
  )
}
